// global import
import { NavPage } from 'views/Global/NavPage/NavPage';
import { PaymentSuccess } from 'views/Payments/PaymentSuccessful';
import { PaymentFailed } from 'views/Payments/PaymentFailed';
import { Certificate } from 'views/Global/Certificate/Certificate.js';
import { InternshipCertificate } from 'views/Global/InternshipCertificate/InternshipCertificate';
import { Achievements } from 'views/Global/Achievements/Achievements.js';

//CTD imports
import { CombTestPane } from 'components/global/NodeLayout/CombinatorialTestPane/CombinatorialTestPane';

const Routes = [
	{
		path: '/navigate',
		view: NavPage,
		layout: 'app',
		permission: 'navigate.view',
		title: 'nav.home',
		mobile: true
	},
	{
		path: '/paymentsuccess',
		view: PaymentSuccess,
		layout: 'public',
		title: 'Payment.PaymentSuccessful.title'
	},
	{
		path: '/paymentfailed',
		view: PaymentFailed,
		layout: 'public',
		title: 'Payment.PaymentFailed.title'
	},
	{
		path: '/achievements',
		view: Achievements,
		layout: 'app',
		permission: 'achievements.view',
		title: 'LearningPath.Achievements.title'
	},
	{
		path: '/certificate/:user_cert_id',
		view: Certificate,
		layout: 'public',
		title: 'LearningPath.Certificate.title'
	},
    {
        path: '/internship/certificate/:internship_cert_id',
        view: InternshipCertificate,
        layout: 'public',
        title: 'InternshipPack.Certificate.title'
    },
	{
		path: '/ctd',
		view: CombTestPane,
		layout: 'appPlain',
		permission: 'ctd.view',
		title: 'Components.NodeLayout.CombinatorialTestPane.title'
	}
]

export default Routes;
